import React, {useState} from 'react';
import {Link} from "@reach/router";
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from "reactstrap";

const FooterLinks = () => {
  const [show, setShow] = useState();

  const accordionHandler = (option) => {
    if (option === show) {
      setShow(null);
    } else {
      setShow(option);
    }
  };

  return (
    <Accordion flush toggle={accordionHandler} open={show} className="d-md-flex justify-content-md-between align-items-md-start">
      <AccordionItem className="d-none d-md-block">
        <AccordionHeader targetId="buy-sell">
          Buy & Sell
        </AccordionHeader>
        <AccordionBody accordionId="buy-sell">
          <Link to={'/buyer'}>
            Buyer
          </Link>
          <Link to={'/seller'}>
            Seller
          </Link>
        </AccordionBody>
      </AccordionItem>
      <AccordionItem>
        <AccordionHeader targetId="pod">
          Payondelivery
        </AccordionHeader>
        <AccordionBody accordionId="pod">
          <Link to={'/about-us'}>
            About Us
          </Link>
          <Link to={'/privacy-policy'}>
            Privacy policy
          </Link>
          <Link to={'/terms-and-conditions'}>
            Terms and conditions
          </Link>
        </AccordionBody>
      </AccordionItem>
      <AccordionItem className="d-md-none">
        <AccordionHeader targetId="blog" className="d-none">
          Blog
        </AccordionHeader>
        <AccordionBody accordionId="blog" className="d-none d-md-block">
          <Link to={'blog'} className="d-none">
            Shopping Tips
          </Link>
        </AccordionBody>
        <div className="d-md-none">
          <Link to={'blog'} className="d-none">
            Blog
          </Link>
          <a href="https://help.payondelivery.com/en/collections/85025-get-started">
            How to buy safely and quickly?
          </a>
          <a href="https://help.payondelivery.com/en/articles/1496041-how-does-payondelivery-work-for-sellers">
            How to sell safely and quickly?
          </a>
        </div>
      </AccordionItem>
      <AccordionItem>
        <AccordionHeader targetId="support">
          Support
        </AccordionHeader>
        <AccordionBody accordionId="support">
          <a href="https://help.payondelivery.com">
            Help Center
          </a>
          <a href="https://help.payondelivery.com">
            FAQ
          </a>
          {/*<a href="https://help.payondelivery.com/en/collections/85035-frequently-asked-questions">*/}
          {/*  FAQ*/}
          {/*</a>*/}
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );
}

export default FooterLinks;
